import { makeApiCall } from "../makeApiCall";
import { DoctorService_URL, OrderManagementService_URL } from "../Url";

export const CancelOrderActions = {
  CANCEL_ORDER_SUCCESS: "CANCEL_ORDER_SUCCESS",
  CANCEL_ORDER_FAILURE: "CANCEL_ORDER_FAILURE",
  SEND_SELECTED_SMS_SUCCESS: "SEND_SELECTED_SMS_SUCCESS",
  SEND_SELECTED_SMS_FAILURE: "SEND_SELECTED_SMS_FAILURE",
};

export function CancelOrderSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: CancelOrderActions.CANCEL_ORDER_SUCCESS,
      payload: props,
    });
  };
}

export function CancelOrderFailureAction(error) {
  return {
    type: CancelOrderActions.CANCEL_ORDER_FAILURE,
    payload: error,
  };
}

// Cancel Order
export function cancelOrderThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${OrderManagementService_URL}/cancelOrder?orderId=${props.orderId}&reasonId=${props.reasonId}&notes=${props.notes}`;
  return makeApiCall(
    postUrl,
    CancelOrderSuccessAction,
    CancelOrderFailureAction,
    "POST",
    null,
    reqHeader,
    props.history
  );
}

// TEMPLATE

export function smsTemplateSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: CancelOrderActions.SEND_SELECTED_SMS_SUCCESS,
      payload: props,
    });
  };
}

export function smsTemplateFailureAction(error) {
  return {
    type: CancelOrderActions.SEND_SELECTED_SMS_FAILURE,
    payload: error,
  };
}

export function sendSelectedSMSThunk(props) {
  const transactionId = `Order-${props.orderId}`;
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const Url = `${DoctorService_URL}/sendSelectedSmsTemplate?orderId=${props.orderId}&transactionId=${transactionId}`;
  return makeApiCall(
    Url,
    smsTemplateSuccessAction,
    smsTemplateFailureAction,
    "POST",
    props.smsTemplate,
    reqHeader,
    props.history
  );
}
